export default class UtilHeight {
    constructor() {
        this.setEvents();
        this.configureHeight();
    }

    setEvents() {
        window.addEventListener('resize', this.configureHeight);
    }

    configureHeight() {
        const doc = document.documentElement;
        doc.style.setProperty('--util-height', `${window.innerHeight}px`);
    }
}